import React from 'react';

const DesktopAdExamples = ({ localisations, siteId, userType }) => {
  return (
    <>
      <p>
        { localisations.how_your_ad_will_look }
      </p>
      {siteId === 1 ? (
        userType === 'offerer' ? (
          <img
            alt="Bold offered ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/uk-ad-examples/srp-4.png?v=2"
          />
        ) : (
          <img
            alt="Bold wanted ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/uk-ad-examples/srp-7.png?v=2"
          />
        )
      ) : null}
      {siteId === 12 ? (
        userType === 'offerer' ? (
          <img
            alt="Bold offered ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/us-ad-examples/srp-4-us.png?v=1"
          />
        ) : (
          <img
            alt="Bold wanted ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/us-ad-examples/srp-1-us.png?v=1"
          />
        )
      ) : null}
      {siteId === 21 ? (
        userType === 'offerer' ? (
          <img
            alt="Bold offered ad example"
            className="modal__ad-example-image"
            src="/img/appartager/screenshots/ad-examples/srp-bold-offered.png?v=1"
          />
        ) : (
          <img
            alt="Bold wanted ad example"
            className="modal__ad-example-image"
            src="/img/appartager/screenshots/ad-examples/srp-bold-wanted.png?v=1"
          />
        )
      ) : null}
      <p>{ localisations.how_your_ad_currently_appears }</p>
      {siteId === 1 ? (
        userType === 'offerer' ? (
          <img
            alt="Non upgraded offered ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/uk-ad-examples/srp-3.png?v=4"
          />
        ) : (
          <img
            alt="Non upgraded wanted ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/uk-ad-examples/srp-6.png?v=4"
          />
        )
      ) : null}
      {siteId === 12 ? (
        userType === 'offerer' ? (
          <img
            alt="Non upgraded offered ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/us-ad-examples/srp-5-us.png?v=1"
          />
        ) : (
          <img
            alt="Non upgraded wanted ad example"
            className="modal__ad-example-image"
            src="/img/spareroom/screenshots/us-ad-examples/srp-2-us.png?v=1"
          />
        )
      ) : null}
      {siteId === 21 ? (
        userType === 'offerer' ? (
          <img
            alt="Non upgraded offered ad example"
            className="modal__ad-example-image"
            src="/img/appartager/screenshots/ad-examples/srp-standard-offered.png?v=1"
          />
        ) : (
          <img
            alt="Non upgraded wanted ad example"
            className="modal__ad-example-image"
            src="/img/appartager/screenshots/ad-examples/srp-standard-wanted.png?v=1"
          />
        )
      ) : null}
    </>
  );
};

export default DesktopAdExamples;
